<template>

  <b-carousel-list
    :icon-pack="iconPack"
    :icon-prev="iconPrev"
    :icon-next="iconNext"
    class="has-background-transparent"
    v-if="okcarousel"
    :data="items"
    :items-to-show="toshow"
  >

    <template slot="item" slot-scope="props">

      <p v-if="toshow==1" class="has-text-grey">
        <small>glisser vers la gauche pour faire defiler</small>
      </p>

      <div class="card">

        <div class="card-image">
          <figure class="image is-3by2x">
            <img
              alt="img"
              v-if="props.list.image"
              :src="props.list.image.path"
              @error="imageUrlAlt"
            />
            <img alt="img" v-if="!props.list.image" :src="imgalt" />
          </figure>

        </div>

        <div class="card-content" id="carouselactus">

          <div class="content">

            <p class="title is-6 pb-2">{{ props.list.title }}</p>

            <p
              class="subtitle is-6 coco"
              v-if="props.list.excerpt"
              v-html="props.list.excerpt"
            ></p>

            <p
              class="subtitle is-6 coco"
              v-else
              v-html="props.list.content"
            ></p>
            <hr />
            <div class="field is-grouped">
              <p class="control subtitle is-7" v-if="props.list.datepost">
                <span title="publié le" class="has-text-grey">
                  <b-icon icon="clock-outline"> </b-icon>
                   {{props.list.datepost | formatDate}}
                </span>

              </p>
              <p class="control" style="margin-left: auto">
                <router-link
                  v-if="props.list.excerpt"
                  class="button is-normal is-danger is-outlined"
                  :to="'/post/'+ props.list._id+'#voir'"
                >
                   Voir plus
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-carousel-list>

</template>


<script>
import axios from 'axios';

export default {
  data() {
    return {
      toshow: window.innerWidth < 640 ? 1 : 3,
      loading: true,
      items: null,
      error: null,
      iconPack: 'mdi',
      iconPrev: 'arrow-left',
      iconNext: 'arrow-right',
      limitperpage: 10,
      curr_path: window.location.origin,
      okcarousel: false,
      imgalt: "https://buefy.org/static/img/placeholder-1280x960.png"
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    imageUrlAlt(event) {
      event.target.src = this.imgalt;
    },

    async fetchData() {
      this.error = null;
      this.items = null;
      this.loading = true;

      const fetchurl = `${this.$api_url_posts}&sort[datepost]=-1`;

      try {
        const response = await axios.get(fetchurl);
        const entries = response.data.entries;

        this.items = entries.slice(0, this.limitperpage).map(item => ({
          _id: item._id,
          title: item.title,
          excerpt: item.excerpt,
          content: item.content,
          datepost: item.datepost,
          image: item.image ? { path: item.image.path } : null
        }));

        this.okcarousel = true;
      } catch (error) {
        console.error("Error fetching data:", error);
        this.error = 'An error occurred while fetching data.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style type="text/css">
.coco {
  height: 140px;
  padding-top: 8px;
  overflow: hidden;
}

.carousel-arrow .icon {
  background: black !important;
  color: #fafafa !important;
}

.carousel-list.has-shadow {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.card {
  box-shadow: 1px 1px 12px #ff4c4c !important;
  margin: 15px 15px !important;
  background: #fff !important;
}
.quillWrapper{
  background-color: white !important;
}
</style>
